import { Defaults } from 'const/Defaults';
import moment from 'moment';
import {
    deleteById,
    executeDeleteCategory,
    executeSaveCategory,
    getById,
    getCategories,
    getLedgerItemsFiltered,
    save,
} from 'rest/RestApiRepository';
import { isNullOrEmpty } from 'utils/StringUtils';

export const getLedgerItem = id => {
    return getById(id);
};

export const saveLedgerItem = ledgerItem => {
    return save(ledgerItem);
};

export const deleteLedgerItem = id => {
    return deleteById(id);
};

export const getLedgerItems = filter => {
    return getLedgerItemsFiltered(filter);
};

export const createLedgerItemsFilter = (baseFilters, advancedFilter) => {
    const startDate = baseFilters?.startDate ? moment(baseFilters.startDate, true) : undefined;
    const endDate = baseFilters?.endDate ? moment(baseFilters.endDate, true) : undefined;

    const baseFilter = Object.fromEntries(
        Object.entries({
            startDate: startDate?.isValid() ? startDate.format(Defaults.DATE_FORMAT) : '',
            endDate: endDate?.isValid() ? endDate.format(Defaults.DATE_FORMAT) : '',
        }).filter(([, value]) => !isNullOrEmpty(value))
    );

    return { ...advancedFilter, ...baseFilter };
};

export const getAllCategories = () => {
    return getCategories();
};

export const saveCategory = category => {
    return executeSaveCategory(category);
};

export const deleteCategory = categoryId => {
    return executeDeleteCategory(categoryId);
};
